/* eslint-disable eag/match-named-export */
import {BOLD_STAR, ITALIC_UNDERSCORE, LINK} from '@lexical/markdown';

export const MARKDOWN_TRANSFORMERS = [BOLD_STAR, ITALIC_UNDERSCORE, LINK];
